import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledBoundlessBenefitsBanner = styled.div`
  display: flex;
  flex-direction: column;
  border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
  border-radius: var(--t-cards-border-radius, ${toRem(14)});
  background-color: ${baseVariables.color['base0']};
  overflow: visible;

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: row;
    align-items: stretch;
  }

  .wallet-boundless-benefits-banner__image-wrapper {
    display: flex;
    width: 100%;
    padding: var(--general-spacer-03, ${toRem(16)});
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--general-spacer-03, ${toRem(16)});
    align-self: stretch;
    box-sizing: border-box;
    border-radius: var(--t-cards-border-radius, ${toRem(14)});
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    background-color: ${baseVariables.color['base0']};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);

    @media ${baseVariables.mediaQuery.md} {
      width: ${toRem(312)};
      flex-shrink: 0;
    }
  }

  .wallet-boundless-benefits-banner__image-wrapper picture {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--general-spacer-02, ${toRem(8)});
    align-self: stretch;
    width: 100%;
  }

  .wallet-boundless-benefits-banner__image {
    display: block;
    width: 100%;
    height: ${toRem(196.96)};
    align-self: stretch;
    aspect-ratio: 30 / 19;
    object-fit: cover;

    @media ${baseVariables.mediaQuery.md} {
      height: ${toRem(177.328)};
    }
  }

  .wallet-boundless-benefits-banner__content {
    display: flex;
    padding: var(--general-spacer-04, ${toRem(24)});
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: var(--general-spacer-03, ${toRem(16)});
    flex: 1 0 0;
    align-self: stretch;
    min-width: 0;
    box-sizing: border-box;
  }

  .wallet-boundless-benefits-banner__header {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--general-spacer-02, ${toRem(8)});

    @media ${baseVariables.mediaQuery.md} {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: var(--general-spacer-03, ${toRem(16)});
    }
  }

  .wallet-boundless-benefits-banner__heading,
  .wallet-boundless-benefits-banner__heading * {
    margin: 0;
    width: 100%;
    min-width: 0;
    color: var(--Color-Set-brand-fg-color, #1c1c1c);
    white-space: normal;
    overflow-wrap: anywhere;

    @media ${baseVariables.mediaQuery.md} {
      flex: 1;
      width: auto;
    }
  }

  .wallet-boundless-benefits-banner__benefits {
    display: flex;
    flex-direction: column;
    gap: var(--general-spacer-03, ${toRem(16)});
    margin: 0;
    padding: 0;
    list-style: none;
    width: 100%;
  }

  .wallet-boundless-benefits-banner__cta.m-link-tertiary-button,
  .wallet-boundless-benefits-banner__cta.m-link-tertiary-button-external {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0;
    white-space: nowrap;
    color: var(--Color-Set-button-tertiary-color, var(--t-button-tertiary-color, ${baseVariables.color['base10']}));
    text-align: center;
    text-decoration: none;

    &:hover,
    &:focus,
    &:focus-visible {
      font-weight: 500;
      text-decoration: none;
      border-bottom-color: transparent;
    }

    &::after {
      position: static;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: ${toRem(16)};
      height: ${toRem(16)};
      padding-left: var(--general-spacer-02, ${toRem(8)});
      font-size: ${toRem(16)};
      line-height: 1;
      vertical-align: middle;
    }
  }

  .wallet-boundless-benefits-banner__benefit {
    display: flex;
    align-items: flex-start;
    gap: var(--general-spacer-03, ${toRem(16)});
    width: 100%;
    min-width: 0;
  }

  .wallet-boundless-benefits-banner__multiplier {
    display: flex;
    width: ${toRem(40)};
    height: ${toRem(40)};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--general-spacer-01, ${toRem(4)});
    aspect-ratio: 1 / 1;
    flex-shrink: 0;
    border-radius: ${toRem(8)};
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    background-color: ${baseVariables.color['base0']};
    overflow: hidden;
  }

  .wallet-boundless-benefits-banner__multiplier-value {
    max-width: 100%;
    overflow: hidden;
    color: var(--t-brand-fg-color, ${baseVariables.color['base10']});
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-boundless-benefits-banner__multiplier-accent {
    display: block;
    width: ${toRem(16)};
    height: ${toRem(3)};
    flex-shrink: 0;
    background-color: ${baseVariables.color['accent10']};
  }

  .wallet-boundless-benefits-banner__description {
    flex: 1;
    min-width: 0;
    color: var(--t-brand-fg-color, ${baseVariables.color['base10']});
    white-space: normal;
    overflow-wrap: anywhere;
  }
`;
